package com.ives.utils.math;

class Vector2D {
	public var x:Float;
	public var y:Float;

	public function new(x:Float = 0, y:Float = 0){
		this.x = x;
		this.y = y;
	}

	public function length2():Float{
		return x * x + y * y;
	}

	public function length():Float{
		return Math.sqrt(length2());
	}

	public function normalize(){
		var length:Float = length();

		this.x /= length;
		this.y /= length;
	}

	public function scale(scale:Float){
		this.x *= scale;
		this.y *= scale;
	}

	public function rotate(deg:Float){
		var radians:Float = (Math.PI/180) * deg;

		var cos:Float = Math.cos(radians);
		var sin:Float = Math.sin(radians);

		var newX:Float = this.x * cos - this.y * sin;
		var newY:Float = this.x * sin + this.y * cos;

		this.x = newX;
		this.y = newY;
	}

	public function increment(vector:Vector2D){
		this.x += vector.x;
		this.y += vector.y;
	}

	public function decrement(vector:Vector2D){
		this.x -= vector.x;
		this.y -= vector.y;
	}

	public function add(vector:Vector2D):Vector2D{
		return new Vector2D(this.x + vector.x, this.y + vector.y);
	}

	public function subtract(vector:Vector2D):Vector2D{
		return new Vector2D(this.x - vector.x, this.y - vector.y);
	}

	public function clone():Vector2D{
		return new Vector2D(this.x, this.y);
	}

	public function cross(vector:Vector2D):Float{
		return this.x * vector.y - this.y * vector.x;
	}

	public function dot(vector:Vector2D):Float{
		return this.x * vector.x + this.y * vector.y;
	}

	public function toString():String{
		return '${x},${y}';
	}
}
